// [for Drag and Drop API]
const d = document.createElement("div");
export default {
	enableDnD: "draggable" in d || ("ondragstart" in d && "ondrop" in d)
};
